import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "content-section" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "h2 mb-3 text-center" }, "Meddelanden", -1)
const _hoisted_3 = { class: "card card-feat" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", { src: "/assets/icons/back-icon.svg" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Tillbaka ")
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  class: "col-sm-6 mb-3"
}
const _hoisted_9 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, "Meddelande", -1)
const _hoisted_11 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "mt-3" }, " Uppskattad svarstid: Inom två timmar under vanliga arbetstider (måndag-fredag 08:00-18:00) ", -1)
const _hoisted_13 = { class: "mt-3" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 0,
  class: "alert alert-secondary mt-3"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("small", null, "Tack för ditt meddelande.", -1)
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectInput = _resolveComponent("SelectInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          role: "button",
          class: "mb-3",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
        }, _hoisted_7),
        _createElementVNode("form", {
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
        }, [
          (_ctx.showLoanOption)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_SelectInput, {
                  label: "Välj Ärende",
                  modelValue: _ctx.form.loanType,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.loanType) = $event)),
                  options: _ctx.loanOptions
                }, null, 8, ["modelValue", "options"]),
                (_ctx.loanType)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Ärende saknas."))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _hoisted_10,
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.message) = $event)),
              id: "messageTextArea",
              class: "col-sm-6",
              rows: 5,
              placeholder: "skriv meddelande"
            }, null, 512), [
              [_vModelText, _ctx.form.message]
            ]),
            (_ctx.message)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, "Meddelande saknas."))
              : _createCommentVNode("", true)
          ]),
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("button", {
              class: "btn btn-outline",
              disabled: _ctx.form.message === ''
            }, " Skicka ", 8, _hoisted_14),
            (_ctx.messageSent)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
              : _createCommentVNode("", true)
          ])
        ], 32)
      ])
    ])
  ]))
}